import { AccountObject, CompanyCodeObject } from "../interfaces/Administration/AccountObject";
import { fetchData, postData } from "./api.service";
import { appInsights } from "../../core/services/insight.service";
import { User } from "@auth0/auth0-react";

export const addAccountObject = async (account: any, userProfile:User): Promise<boolean> => {
    try {
        const response = await postData<boolean>(
            `ManageApplication/add-account-object`,
            account,
            userProfile
        );
        return response;
    } catch (error: any) {
        appInsights.trackEvent({ name: "AddAccountObjectFailed", properties: { error: error } });
        throw error;
    }
};

export const addCompanyCode = async (companyCode: any,userProfile:User): Promise<boolean> => {
    try {
        const response = await postData<boolean>(
            `ManageApplication/add-companycode`,
            companyCode,
            userProfile
        );
        return response;
    } catch (error: any) {
        appInsights.trackEvent({ name: "AddCompanyCodeFailed", properties: { error: error } });
        throw error;
    }
};

export const addSubsidiary = async (subsidiary: any, userProfile:User): Promise<boolean> => {
    try {
        const response = await postData<boolean>(
            `ManageApplication/add-subsidiary`,
            subsidiary,
            userProfile
        );
        return response;
    } catch (error: any) {
        appInsights.trackEvent({ name: "AddSubsidiaryFailed", properties: { error: error } });
        throw error;
    }
};

export const fetchAccountObjectsData = async (userProfile:User): Promise<AccountObject[]> => {
    try {
        const response = await fetchData<AccountObject[]>(`ManageApplication/get-account-object`, userProfile);
        return response;
    } catch (error: any) {
        appInsights.trackEvent({ name: "FetchAccountObjectsDataFailed", properties: { error: error } });
        throw error;
    }
};
